
import { defineComponent, computed, useAttrs } from "vue";

// Define an interface for the style attributes
interface StyleAttributes {
  defaultBorder?: string;
  borderColor?: string;
  borderWidth?: string;
  borderStyle?: string;
  padding?: string;
  margin?: string;
}

export default defineComponent({
  props: {
    isPreview: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {
    const attrs = useAttrs();
    const dynamicAttrs = computed(() => {
      const clonedAttrs = { ...attrs };
      // Type assertion for style attributes
      const styleAttrs = clonedAttrs.style as StyleAttributes;

      // Check if attrs.style.defaultBorder is "true !important"
      if (styleAttrs && styleAttrs.defaultBorder === "true !important") {
        styleAttrs.borderColor = "";
        styleAttrs.borderWidth = "";
        styleAttrs.borderStyle = "";
        styleAttrs.padding = "";
        styleAttrs.margin = "";
        clonedAttrs.borderColor = "";
        clonedAttrs.borderWidth = "";
        clonedAttrs.borderStyle = "";
        clonedAttrs.padding = "";
        clonedAttrs.margin = "";
      }

      return clonedAttrs;
    });
    return {
      dynamicAttrs,
    };
  },
});
